import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";

export const ModalSingleDebit = ({
  show,
  toggle,
  handleUpdateResumptionDate,
  isUpdating,
  mandateInfo,
  resumption, 
  setIsResumption,
  note, 
  setNote,
  handleTransaction
}) => {
  
  const navigate = useNavigate();
  const [proceed, setProceed] = useState(false)
  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Debit Mandate</Modal.Title>
        </div>
      </Modal.Header>
      {!proceed && <div>
      <Modal.Body>
        <p>Are you sure you want to debit this mandate?</p>
        <Form onSubmit={(e) => {
          e.preventDefault()
            setProceed(true)
          }}>
          <Form.Group>
            <Form.Label>Count</Form.Label>
            <Form.Select
              value={resumption}
              required
              onChange={(e) => setIsResumption(e.target.value)}
            >
              <option value="">-- Select count --</option>
              <option value="1">1 Premium</option>
              <option value="2">2 Premiums(s)</option>
              <option value="3">3 Premiums(s)</option>
              <option value="4">4 Premiums(s)</option>
              <option value="5">5 Premiums(s)</option>
              </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>Reason for changing</Form.Label>
            <Form.Control
            required
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Form.Group>
          <div style={{padding: "16px", display: "flex", justifyContent: "flex-end"}}>
      <Button
      type="submit"
          style={{
            // backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          
          disabled={isUpdating}
        >
          Proceed
        </Button>
      </div>
        </Form>
      </Modal.Body>
      
      </div>}
      {proceed && 
      <div><div style={{padding: "16px"}}>
          <p style={{fontWeight: "bold", fontSize: "20px"}}>Summary:</p>
          <p>The mandate <span style={{fontWeight: "bold"}}>{mandateInfo?.mandateCode}</span> with Account Number <span style={{fontWeight: "bold"}}>{mandateInfo?.accountNumber}</span> and Policy number <span style={{fontWeight: "bold"}}>{mandateInfo?.contractId}</span> is about to be debitted {resumption} times.</p>
          <p style={{fontWeight: "bold", fontSize: "18px", marginBottom: "0px"}}>Reason:</p>
          <p>{note}</p>
          <p style={{marginBottom: "0px"}}>Debit Count: {resumption}</p>
          <p><span style={{fontWeight: "bold"}}>Total Amount:</span> {(Number(resumption) * Number(mandateInfo?.amount)).toLocaleString()}</p>
        </div>
      <Modal.Footer>
      <Button
      type="button"
          style={{
            backgroundColor: "transparent",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
            marginRight: "10px",
            color: "black",
            border: "1px solid black"
          }}
          onClick={() => {
            setProceed(false)
          }}
          disabled={isUpdating}
        >
          Back
        </Button>
        <Button
          style={{
            // backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          onClick={async () => {
            if (note === "") {
              notify("warning", "Notice", "Reason is compulsory");
            } else {
              await handleUpdateResumptionDate(resumption, note);
              if(!isUpdating){
                setProceed(false)
              }
            }
          }}
          disabled={isUpdating}
        >
          {isUpdating ? "Debitting, please wait.." : "Proceed to debit"}
        </Button>
      </Modal.Footer>
      </div>}
    </Modal>
  );
};
